import type {Dictionary} from "lodash";
import React from "react";
import {PricingTierItem} from "src/utils/fetchPricingData";

import SectionGroup from "./SectionGroup";

interface SectionGroupListProps {
  pricesGroupedByType: Dictionary<PricingTierItem[]>;
}

const SectionGroupList: React.FC<SectionGroupListProps> = ({pricesGroupedByType}) => (
  <div data-testid="section-group-list">
    {Object.keys(pricesGroupedByType).map(name => (
      <SectionGroup key={`section-${name}`} title={name} items={pricesGroupedByType[name]} />
    ))}
  </div>
);

export default React.memo(SectionGroupList);
